<div class="overflow-y-auto">
  <div class="p-2">
    <ng-container *ngIf="this.data?.id; else createNewBoxPickupSite">
      <p class="pb-1 py-0 text-xl font-bold">Edit {{ this.data?.name }} Box Pickup Site</p>
    </ng-container>
    <ng-template #createNewBoxPickupSite>
      <p class="pb-1 py-0 text-xl font-bold">Add New Box Pickup Site</p>
    </ng-template>
    <p style="font-size: 14px;">This site will be available for use when creating an order with a box pickup task</p>
  </div>
  <div class="p-2">
    <form [formGroup]="createBoxPickUpSiteFormGroup">
      <mat-card-content *ngIf="!this.data?.id">
        <p class="text-base pb-1" style="color: #828282">Well</p>
        <mat-form-field class="w-full" appearance="outline">
          <mat-select formControlName="frac" placeholder="Select an existing well to be made a box pickup site">
            <mat-select-trigger>{{ selectedFrac$?.value?.jobName }}</mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Fracs'"
                [noEntriesFoundLabel]="'No frac found'"
                [formControl]="filterFrac"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let frac of fracs$ | async" [value]="frac">
              {{ frac.jobName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card-content>

      <div>
        <p class="text-base pb-1" style="color: #828282">Site Name</p>
        <mat-form-field class="w-full" appearance="outline">
          <input matInput type="text" [formControl]="siteNameFormControl" />
          <mat-error *ngIf="createBoxPickUpSiteFormGroup.controls['siteName'].hasError('required')">
            Site Name is required
          </mat-error>
        </mat-form-field>
      </div>

      <mat-card-content>
        <p class="text-base pb-1" style="color: #828282">Out of Route Miles</p>
        <mat-form-field class="w-full" appearance="outline">
          <input matInput sa-number-input type="number" [formControl]="outOfRouteMilesFormControl" />
          <span matSuffix class="pl-1">miles</span>
        </mat-form-field>
      </mat-card-content>

      <mat-card-content>
        <p class="text-base pb-1" style="color: #828282;">$/Mile</p>
        <mat-form-field class="w-full" appearance="outline">
          <span matPrefix class="pr-1">$</span>
          <input matInput saCurrencyInput type="number" [formControl]="costPerMileFormControl" />
        </mat-form-field>
      </mat-card-content>

      <div class="col-span-2" id="map-box-pickup-location"></div>

      <div class="flex gap-2" style="margin-top: 16px">
        <div class="w-1/3">
          <p class="text-base pb-1" style="color: #828282;">Latitude</p>
          <mat-form-field class="w-full" appearance="outline">
            <input matInput type="number" [formControl]="latitudeFormControl" />
            <mat-error *ngIf="createBoxPickUpSiteFormGroup.controls['latitude'].hasError('required')">
              Latitude is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="w-1/3">
          <p class="text-base pb-1" style="color: #828282;">Longitude</p>
          <mat-form-field class="w-full" appearance="outline">
            <input matInput type="number" [formControl]="longitudeFormControl" />
            <mat-error *ngIf="createBoxPickUpSiteFormGroup.controls['longitude'].hasError('required')">
              Longitude is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="w-1/3">
          <p class="text-base pb-1" style="color: #828282;">Radius</p>
          <mat-form-field class="w-full" appearance="outline">
            <input matInput type="number" [formControl]="radiusInMilesFormControl" />
            <mat-error *ngIf="createBoxPickUpSiteFormGroup.controls['radiusInMiles'].hasError('required')">
              Radius is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div>
        <p class="text-base" style="color: #828282;">Directions to Well</p>
        <mat-form-field class="w-full" appearance="outline">
          <textarea matInput type="text" [formControl]="directionsFormControl"></textarea>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="flex-start" class="action-buttons" style="overflow: auto">
        <button
          *ngIf="!this.data"
          [disabled]="createBoxPickUpSiteFormGroup.invalid"
          mat-flat-button
          color="primary"
          type="submit"
          class="next-btn"
          style="margin-right: 1em;"
          (click)="submitForm()"
        >
          ADD
        </button>
        <button
          *ngIf="this.data"
          [disabled]="createBoxPickUpSiteFormGroup.invalid"
          mat-flat-button
          color="primary"
          type="submit"
          class="next-btn"
          style="margin-right: 1em;"
          (click)="updateBoxPickupSite()"
        >
          UPDATE
        </button>
        <button mat-stroked-button color="warn" type="button" class="next-btn" (click)="cancelAction()">
          CANCEL
        </button>
      </div>
    </form>
  </div>
</div>
